module.exports = __webpack_public_path__ + "img/ic_12_arrow_white.1889c02a.svg";